import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api/puppies`;

export const puppyService = {
  // Get all puppies
  getAll: async () => {
    const response = await axios.get(API);
    return response.data;
  },

  // Get single puppy
  getById: async (id) => {
    const response = await axios.get(`${API}/${id}`);
    return response.data;
  },

  // Create new puppy
  create: async (puppyData) => {
    const response = await axios.post(API, puppyData);
    return response.data;
  },

  // Update puppy
  update: async (id, puppyData) => {
    const response = await axios.put(`${API}/${id}`, puppyData);
    return response.data;
  },

  // Delete puppy
  delete: async (id) => {
    const response = await axios.delete(`${API}/${id}`);
    return response.data;
  },

  // Upload image
  uploadImage: async (file) => {
    const formData = new FormData();
    formData.append('file', file);
    const response = await axios.post(`${API}/upload-image`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data.image;
  },

  // Seed initial data
  seed: async () => {
    const response = await axios.post(`${API}/seed`);
    return response.data;
  }
};
